<template lang="html">
  <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" />
  <h1 class="title text-light">Vul je naam in</h1>
  <input
    v-model="firstName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Voornaam"
    required
  />
  <input
    v-model="lastName"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Achternaam"
    required
  />
  <!-- <input
    v-model="company"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Bedrijfsnaam"
    required
  />
  <input
    v-model="email"
    class="form-control field no-focusborder"
    type="email"
    ref="inputfield"
    placeholder="E-mailadres"
    required
  />
  {{ validateEmail }} -->
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary btn-lg"
      :disabled="isDisabled == true"
      @click="setPersonalData()"
    >
      Doorgaan
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    company: null,
    email: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.lastName) {
        return false;
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      // this.$store.commit("setCompany", this.company);
      // this.$store.commit("setEmail", this.email);
      // this.$store.commit("setEmail", this.email);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 30px;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 100%;
  padding: 10px;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 20px;
  color: #000;
  background-color: rgba(255, 255, 255, 0.8);
}
.field::placeholder {
  color: #555;
  opacity: 0.5;
}
</style>
